<template>
    <div class="page-container">
        <div class="head-title">
            <div class="left">
                <ul class="breadcrumb">
                    <li>
                        <a href="#" class="active">{{ $t("accounting") }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="main-card">
            <div class="body-grid">
                
                <div class="part" v-if="hasPermission('account_tree_view') || hasPermission('opening_balance_view') || hasPermission('commissions_view')">
                    <h6>{{ $t("Accounts") }}</h6>
                    <ul>
                        <li v-if="hasPermission('account_tree_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/ChartOfAccounts">{{ $t("chart of accounts") }}</router-link>
                        </li>
                        <li v-if="hasPermission('opening_balance_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/OpeningBalance">{{ $t("balance") }} {{ $t("opening") }}</router-link>
                        </li>
                        <li v-if="hasPermission('commissions_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/AllCommissions">{{ $t("Commissions") }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="part" v-if="hasPermission('journal_entry_view') || hasPermission('quick_entry_view')">
                    <h6>{{ $t("Payments") }}</h6>
                    <ul>
                        <li v-if="hasPermission('journal_entry_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/JournalEntry">{{ $t("Journal Report") }}</router-link>
                        </li>
                        <li v-if="hasPermission('quick_entry_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/AllFastJL">{{ $t("fastjl") }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="part" v-if="hasPermission('cost_center_guide_view')">
                    <h6>{{ $t("ccenter") }}</h6>
                    <ul>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/costcenter">{{ $t("Cost Centers Guide") }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="part" v-if="hasPermission('general_ledger_view') || hasPermission('general_ledger_summary_view') || hasPermission('account_statement_view')">
                    <h6>{{ $t("reports") }} {{ $t("General Ledger") }}</h6>
                    <ul>
                        <li v-if="hasPermission('general_ledger_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/JournalReport">{{ $t("General Ledger") }} {{ $t("general") }}</router-link>
                        </li>
                        <li v-if="hasPermission('general_ledger_summary_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/GeneralLedgerSummary">{{ $t("summary") }} {{ $t("General Ledger") }} {{ $t("general") }}</router-link>
                        </li>
                        <li v-if="hasPermission('account_statement_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/GeneralLedgerSummaryDaily/0/0/0/0/0/0">{{ $t("Account Statement") }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="part" v-if="hasPermission('trial_balance_view') || hasPermission('income_statement_view') || hasPermission('balance_sheet_view') || hasPermission('revenues_view')">
                    <h6>{{ $t("data") }} {{ $t("financial") }}</h6>
                    <ul>
                        <li v-if="hasPermission('trial_balance_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/TrialBalance">{{ $t("Trial Balance") }}</router-link>
                        </li>
                        <li v-if="hasPermission('income_statement_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/IncomeStatement">{{ $t("Income Statement") }}</router-link>
                        </li>
                        <li v-if="hasPermission('balance_sheet_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/FinancialCenter">{{ $t("Financial Center") }}</router-link>
                        </li>
                        <li v-if="hasPermission('revenues_view')">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/accounting/RevenuesReport">{{ $t("revenues") }}</router-link>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  title: "Accounting",
  props: ["css"],
  data() {
    return {};
  },
  methods: {
    ...mapActions(["redirectTo"]),
    // Added helper placeholder to safely evaluate rules syntax within example code
    hasPermission(permission) {
      return this.$store?.getters?.hasPermission ? this.$store.getters.hasPermission(permission) : true;
    }
  },
};
</script>

<style lang="scss" scoped>
/* Reset and Container Basics */
.page-container {
    direction: v-bind("css.EN");
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: #f8f9fa;
    min-height: 100vh;
}

.breadcrumb {
    list-style: none;
    padding: 0;
    margin-bottom: 20px;
    
    li a {
        text-decoration: none;
        font-weight: 600;
        font-size: 1.2rem;
        color: #333;
        
        &.active {
            color: v-bind("css.color");
        }
    }
}

/* Main Dashboard Card Wrapper */
.main-card {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    padding: 24px;
}

/* Bottom Navigation Grid System */
.body-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 24px;
}

.part {
    background-color: #ffffff;
    border: 1px solid #edf2f7;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    align-self: start; /* Fixes dynamic heights from causing structural elongation */

    h6 {
        font-size: 16px;
        font-weight: 700;
        color: #1a202c;
        margin-top: 0;
        margin-bottom: 16px;
        border-bottom: 2px solid #edf2f7;
        padding-bottom: 8px;
        text-transform: uppercase;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            font-size: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            .bi-three-dots-vertical {
                color: #a0aec0;
                margin-right: 8px;
                font-size: 14px;
            }

            a {
                color: #4a5568;
                text-decoration: none;
                transition: color 0.2s;

                &:hover {
                    color: v-bind("css.color");
                    font-weight: 500;
                }
            }
        }
    }
}

/* Responsive Breakpoints */
@media screen and (max-width: 992px) {
    .body-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (max-width: 576px) {
    .page-container {
        padding: 10px;
    }
    
    .main-card {
        padding: 16px;
    }

    .body-grid {
        grid-template-columns: 1fr;
        grid-gap: 16px;
    }
    
    .part {
        padding: 16px;
        
        h6 {
            font-size: 14px;
            margin-bottom: 12px;
        }
        
        ul li {
            font-size: 14px;
            margin-bottom: 10px;
        }
    }
}
</style>